module.exports = "https://static.wagwalking.com/_next/static/images/wellness-mobile-v2-1dd5ede5bd7b87ef87d27fcc998583ff.png";